import { Input, Spin } from "antd";
import React, { useRef, useState } from "react";

function Loading(props) {
  // MARK: --- Params ---
  const {} = props;

  return (
    <div className="fixed inset-0 flex flex-col space-y-4 items-center justify-center bg-black bg-opacity-20 z-50">
      <div className="z-100 bg-white p-8 px-16 flex flex-col space-y-4">
        <Spin size="large" />
        <span>Loading ...</span>
      </div>
    </div>
  );
}

export default Loading;
